var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThinborder4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1038_6108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-712.572 -503.32H1.2601C1.67338 -503.32 2.03745 -503.054 2.17521 -502.661C5.50108 -492.732 13.4123 -484.82 23.3407 -481.494C23.7343 -481.366 24 -480.992 24 -480.579V1.25861C24 1.67191 23.7343 2.03601 23.3407 2.17377C13.4123 5.49986 5.50108 13.4116 2.17521 23.3407C2.04729 23.7343 1.67338 24 1.2601 24H-712.572C-712.985 24 -713.349 23.7343 -713.487 23.3407C-716.813 13.4116 -724.724 5.49986 -734.653 2.17377C-735.046 2.04585 -735.312 1.67191 -735.312 1.25861V-480.579C-735.312 -480.992 -735.046 -481.356 -734.653 -481.494C-724.724 -484.82 -716.813 -492.732 -713.487 -502.661C-713.359 -503.054 -712.985 -503.32 -712.572 -503.32ZM0.581154 -501.401H-711.883C-715.445 -491.423 -723.406 -483.462 -733.373 -479.91V0.569777C-723.396 4.13204 -715.435 12.093 -711.883 22.0713H0.581154C4.14318 12.093 12.1036 4.13204 22.0812 0.569777V-479.9C12.1036 -483.462 4.14318 -491.423 0.581154 -501.391V-501.401Z",
    fill: "#C4944D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1038_6108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 -1 24 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinborder4);
export default __webpack_public_path__ + "static/media/Thinborder4.e25dae2d817262ec149838d518fa2d5c.svg";
export { ForwardRef as ReactComponent };